
import axios from 'axios';
import { Base64 } from 'js-base64';
import moment from 'moment/moment';
import debounce from 'lodash/debounce';
import { useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { origin } from '../../Config/Api-constants';
import SelectedTemplateView from './SelectedTemplateView';
import "../../../Assets/Styles/Containers/_dashboard.scss";
import '../../../Assets/Styles/Containers/_inspection.scss';
import { useState, useEffect, useRef, useCallback } from 'react';
import { Box, CircularProgress, Dialog, DialogActions, DialogTitle, Divider, Paper, Grid, TextField, InputAdornment, Typography } from '@mui/material';

const FromExistingTemplate = ({ open, handleClose, setZeroState }) => {
    const storeData = useSelector((state) => state.CommonReducer);

    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [suggestedOrders, setSuggestedOrders] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const dialogContentRef = useRef(null);

    const getCompanyPlaceholders = async (pageNum = 1, searchQuery = '') => {
        const baseUrl = await origin();
        const sessionAPIKey = sessionStorage.getItem("CK");
        const sessionSecretKey = sessionStorage.getItem("SK");
        const clientName = storeData?.inspectionData?.data?.clientName;
        const address = storeData?.inspectionData?.data?.location_address;

        console.log(address,"storeData")

        try {
            setLoading(true);
            const rowsPerPage = searchQuery ? 200 : 10;

            // Start building the URL
            let url = `${baseUrl}company-order?page=${pageNum}&rows_per_page=${rowsPerPage}`;

            // Add parameters conditionally
            if (!searchQuery) {
                url += `&address=${encodeURIComponent(address)}`;
                url += `&address=${encodeURIComponent(address)}`;
            } else {
                url += `&search=${encodeURIComponent(searchQuery)}`;
            }

            const response = await axios({
                method: "get",
                url,
                headers: {
                    Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                    "api-key": `${Base64.decode(sessionAPIKey)}`,
                    "Content-Type": "application/json",
                    "platform": 'web',
                    "api-platform": 'WRW',
                    "user_id": sessionStorage.getItem('UID'),
                    "product": sessionStorage.getItem('asoCom'),
                    "mode": 'online',
                },
            });

            const newData = response?.data?.data?.data ?? [];

            if (newData.length > 0) {
                setSuggestedOrders(prev => pageNum === 1 ? newData : [...prev, ...newData]);
                setFilteredOrders(prev => pageNum === 1 ? newData : [...prev, ...newData]);
                setPage(pageNum);
            }

            if (newData.length === 0) {
                setHasMore(false);
            }

        } catch (error) {
            console.error("Error during pagination:", error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        if (open) {
            setSuggestedOrders([]);
            setFilteredOrders([]);
            setPage(1);
            setHasMore(true);
            setLoading(false);
            getCompanyPlaceholders(1);
        }
    }, [open]);



    const handleScroll = () => {
        const el = dialogContentRef.current;

        if (!el || loading || !hasMore) return;
        if (searchText.trim()) {
            return;
        }

        if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50) {
            getCompanyPlaceholders(page + 1);
        }
    };

    const handleSearch = useCallback(
        debounce((query) => {
            // if (!query || query.length <= 3) return; 
            setPage(1);
            setFilteredOrders([]);
            setSuggestedOrders([]);
            setHasMore(true);

            getCompanyPlaceholders(1, query);
        }, 850),
        []
    );



    const handleModalClose = () => {
        handleClose();
        setSearchText("");
    }

    function formatAddress(order) {
        if (!order) return '';

        const { address1, city, state, zip } = order;

        const parts = [address1, city, state, zip].filter(part => part && part.trim() !== '');
        return parts.join(', ');
    }



    return (
        <Dialog
            open={open}
            aria-labelledby="category-modal"
            sx={{ borderRadius: "8px !important", }}
            className='dialog-container-import-template'
            aria-describedby="category-modal-description"
        >
            <div className="close-wrapper-new-line">
                <CloseIcon onClick={handleModalClose} />
            </div>
            <DialogTitle className='new-category-dialog-title mb-6'>{"Import from previous order"}</DialogTitle>
            <span className='category-dialog-subtitle p-custom' style={{ marginTop: "-30px" }}>Import completed templates from related orders</span>
            {/* Search */}
            {!selectedTemplate && <Grid container sx={{ p: "5px 38px" }} className="input-search-control">
                <Grid item xs={12} sx={{ mb: "16px" }}>
                    <TextField
                        fullWidth
                        placeholder="Search"
                        variant="outlined"
                        size="small"
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e.target.value);
                            handleSearch(e.target.value);
                        }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: "#3b3b3b", fontSize: "20px" }} />
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: '6px',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                '& fieldset': {
                                    borderColor: '#D5D5D5',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#D5D5D5',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#D5D5D5',
                                },
                            },
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography className='prev_deleted_lable'>SUGGESTED ORDERS</Typography>
                </Grid>
            </Grid>}
            {/* Scrollable Content */}
            {selectedTemplate ? <SelectedTemplateView
                template={selectedTemplate}
                onBack={() => setSelectedTemplate(null)}
                setZeroState={setZeroState}
                handleClose={handleClose}
            /> : <Box
                ref={dialogContentRef}
                onScroll={handleScroll}
                className="dialog-content-import-template"
                sx={{
                    maxHeight: '400px',
                    overflowY: 'auto',
                    padding: '10px 38px',
                    backgroundColor: '#fff',
                }}
            >
                <Grid container className="input-search-control" >
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            {filteredOrders.length === 0 && !loading ? <Typography className='no_suggestion_found'>No suggested orders found.<br />
                                Search by address, client name, or order number.</Typography> : filteredOrders.map((order, index) => (
                                    <Grid item xs={12} sm={6} key={index}>
                                        <Paper
                                            variant="outlined"
                                            sx={{
                                                borderRadius: 2,
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'space-between',
                                                cursor: "pointer",
                                            }}
                                            onClick={() => setSelectedTemplate(order)}
                                        >
                                            <Box sx={{ p: "7px 12px", display: 'flex', justifyContent: 'space-between', mb: 0.5, mt: 0.5 }}>
                                                <Typography variant="body2" color="text.primary">
                                                    {moment(order?.orderStartDate).format('M/D/YYYY h:mm a')}
                                                </Typography>
                                                <Typography variant="body2" color="text.primary">
                                                    Order #{order?.orderId}
                                                </Typography>
                                            </Box>
                                            <Divider />
                                            <div style={{ padding: "12px" }}>
                                                <Typography className='dialog-address-typography'>
                                                    {formatAddress(order)}
                                                </Typography>
                                                {order?.clients?.length > 0 && order?.clients?.map((e => {
                                                    return (<Typography variant="body1" color="text.secondary">
                                                        {e?.name}
                                                    </Typography>)
                                                }))}
                                            </div>
                                        </Paper>
                                    </Grid>
                                ))}

                        </Grid>
                        {loading && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <CircularProgress size={24} />
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Box>}
            {!selectedTemplate && <DialogActions className='template-selection-modal-action'>
                <div id="template_selection_error_text"></div>
            </DialogActions>}
        </Dialog>
    );
};


export default FromExistingTemplate
